import React from 'react';

import { Container } from '@mui/material';

import PageSubheader from '~/components/Common/Elements/PageSubheader';

import TaxEstimationPanel from './TaxEstimationPanel';

export default function TaxEstimationPage() {
  return (
    <Container maxWidth="xl">
      <PageSubheader title="Government tax estimates" />
      <TaxEstimationPanel />
    </Container>
  );
}
